export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/village/queryPage?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
          data
        });
      },

      save(data){
          return http.json({
              url: '/butler/village/manage/save',
              data
          })
      },

      deleteButler(params){
          return http.json({
              url: '/butler/village/delete',
              params
          })
      },

      listByVillageId(villageId){
          return http.json({
            url: '/butler/village/listByVillageId',
            params: {
              'villageId' : villageId
            }
        })
      },
      saveHouseInfo(data){
          return http.json({
            url: '/butler/village/manage/save/house',
            data
        })
      },
      getButlerInfo(data) {
          return http.json({
              url: `/butler/get?id=${data.id}`
          })
      },
      getVillageButlerInfo(data) {
          return http.json({
              url: `/butler/village/get?id=${data.id}`
          })
      },

      saveButlerInfo(data){
          return http.json({
              url: '/butler/updateButler',
              data
          })
      },

  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/butler.js